export default __webpack_public_path__ + "static/media/wikia.03a38f98.png";